import { IPublicationPackagesState } from '../../../../reducers/v2';
import { IServicePackagePeriod } from '../../../../repositories/billing-tariffs/entities/PublishTerms/ServicePackagePeriod';
import { getPackageId } from './getPackageId';
import { getServiceId, mapInternalServiceTypes } from '../../../../utils/publishTerms';
import { EServiceType } from '../../../../types/reducers/publishTerms';
import { EServiceTypes } from '../../../../repositories/billing-tariffs/entities/Models/TariffIdentificator';
import { defaultTo } from 'ramda';
import { mapTariffId } from './mapTariffId';

export const mapPublicationPackages = (servicePackages: IServicePackagePeriod[]): IPublicationPackagesState => {
  return {
    disabled: false,
    packagesList: servicePackages.map(service => {
      const id = getPackageId(service);
      const services = mapInternalServiceTypes<EServiceType>(
        service.tariffIdentificator?.serviceTypes as EServiceTypes[],
      );
      const serviceId = getServiceId(services);

      return {
        days: defaultTo(0, service.days),
        id,
        label: defaultTo('', service.label),
        marketingPrice: service.marketingPrice,
        offersCount: defaultTo(0, service.servicePackageActualCount),
        price: service.price,
        selected: service.isDefault,
        token: defaultTo('', service.token),
        serviceId,
        endDate: defaultTo('', service.servicePackageEndDate),
        type: service.type,
        tariffIdentificator: mapTariffId(service.tariffIdentificator!),
      };
    }),
  };
};
